import { combineReducers } from "redux";
import externalOfficeStatsReducer from "external/reports/officeStats/reducer";
export const externalReportsReducer = combineReducers({
    officeData: externalOfficeStatsReducer
});
